(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var sections = document.querySelectorAll('main .shopify-section');
  if (prefersReduced || !('IntersectionObserver' in window) || sections.length === 0) {
    sections.forEach(function (section) {
      section.classList.add('scroll-reveal--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
})();
